/**
 * MultiAlert.jsx
 * Created by michaelbray on 8/6/18.
 */

import React from 'react';
import PropTypes from 'prop-types';

import * as Icons from '../../sharedComponents/icons/Icons';

const propTypes = {
    alertClassName: PropTypes.string,
    alertIcon: PropTypes.node,
    alertTitle: PropTypes.string,
    alerts: PropTypes.array,
    closeAlert: PropTypes.func
};

const defaultProps = {
    alertClassName: "",
    alertIcon: null,
    alertTitle: "",
    alerts: []
};

export default class MultiAlert extends React.Component {
    constructor(props) {
        super(props);

        const locationType = props.alerts.length > 1 && props.alerts[0].location_type ? props.alerts[0].location_type : 'area';

        this.state = {
            locationType,
            visibility: false
        };

        this.toggleVisibility = this.toggleVisibility.bind(this);
    }

    shouldComonentUpdate(nextProps, nextState) {
        if (nextState.locationType !== this.state.locationType
            || nextState.visibility !== this.state.visibility
            || nextProps.alerts.length !== this.props.alerts.length) {
            return true;
        }

        return false;
    }

    componentWillReceiveProps(nextProps) {
        const locationType = nextProps.alerts.length > 1 && nextProps.alerts[0].location_type ? nextProps.alerts[0].location_type : 'area';

        this.setState({
            locationType
        });
    }

    toggleVisibility() {
        this.setState((prevState) => {
            return {
                visibility: !prevState.visibility
            };
        });
    }

    render() {
        return (
            <div className={`rec-mgs-is-multi-line ${this.props.alertClassName}`}>
                <div className="rec-msg">
                    <div className="rec-msg-text">
                        <div className="rec-msg-text-type">
                            <div className="rec-alerts-notification-icon">
                                {this.props.alertIcon}
                            </div>
                            <strong>
                                {this.props.alertTitle}
                            </strong>
                        </div>
                        <span>
                            There are <strong>{this.props.alerts.length} notifications</strong> for
                            this {this.state.locationType}
                        </span>
                    </div>
                    <button onClick={this.toggleVisibility}>
                        {this.state.visibility ? <Icons.IconChevronUp /> : <Icons.IconChevronDown />}
                        <span className="rec-msg-btn-text">
                            {this.state.visibility ? 'Hide' : 'Show'} Notifications
                        </span>
                    </button>
                </div>

                {this.state.visibility && (
                    <div className="rec-msg-multi-line-wrap">
                        <div className="rec-msg-text-content">
                            <ul>
                                {
                                    this.props.alerts.map((alert) => {
                                        return (
                                            <li key={alert.id}>
                                                {alert.body}
                                            </li>
                                        );
                                    })
                                }
                            </ul>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

MultiAlert.propTypes = propTypes;
MultiAlert.defaultProps = defaultProps;
